<template>
    <Layout>

    <section class="section">
		<div class="container">
			<div class="no-free-will">
				<h3>Regional Outlook</h3>
				<p>2020 will be a challenging year as the longest US economic expansion in many decades continues. US and EM rate cuts offer a tailwind for FEM markets, while flows into EM started recovering in late 2019, but long-standing assumptions about trade and financial flows are being questioned. Key themes to watch include: Kuwait’s EM upgrade in May, and the impact of rate cuts on markets in Pakistan, Egypt and potentially Kenya.</p>
			</div>
		</div>
	</section>

	<!-- Egypt -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/bahrain.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Bahrain</h2>
			<p>Bahrain’s near-term financial constraints have been alleviated by the USD 10 bn support package received from its fellow GCC countries, notably toning down macro-level risks. The government continues to implement fiscal measures to support growth, including the introduction of a VAT. Growth will continue to hinge on the government’s ability to deliver on the remaining fiscal objectives announced in its Fiscal Balance Programme.</p>
		</div>
	</section>

	<!-- UAE -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/bangladesh.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Bangladesh</h2>
			<p>Bangladesh’s robust macroeconomic stability and growth are likely to persist in 2020. Supported by strong remittance inflows and rising exports, a vibrant manufacturing sector and strong growth in private consumption will keep Bangladesh on a positive trajectory. Downside risks mostly emanate from a lingering fiscal deficit, which is driven by increased current spending and disappointing revenue performance.</p>
		</div>
	</section>

	<!-- Qatar -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/egypt.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Egypt</h2>
			<p>Following three years of austerity, in 2020 Egypt’s economy is set to enjoy the benefits of fiscal and monetary easing. The Central Bank has cut rates to levels close to those prevailing prior to Egypt’s entry into an IMF programme, while the government has recently mandated a doubling of the minimum wage and pensions and raised public sector wages. Now that interest rates are more amenable to capital expenditure, private investment is set to pick up over the coming year, although the pace of investment growth will be constrained by a weak private consumption backdrop. The EGP will likely to continue to enjoy the support of inflows from the carry trade, record tourism receipts and the return of Egypt’s energy balance to surplus.</p>
		</div>
	</section>

	<!-- Oman -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/georgia.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Georgia</h2>
			<p>Continued implementation of structural reforms has increased the economy’s resilience to external shocks. Georgian growth is likely to remain robust despite several downside risks linked to external developments. Relative stability in the exchange rate is expected to keep inflation anchored to a low rate in the single digits. </p>
		</div>
	</section>

	<!-- KSA -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/jordan.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Jordan</h2>
			<p>Heightened political tensions in the region and globally will continue to overshadow Jordan’s economic outlook, although fiscal reforms and continued assistance from donors will likely help authorities deliver on growth-friendly policies and reforms, paving the way for an increase in economic activity in 2020.</p>
		</div>
	</section>

	<!-- Bahrain -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/kenya.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Kenya</h2>
			<p>Kenya’s growth outlook remains positive despite worrying fiscal trends. Although the government remains under pressure to adopt much-needed fiscal consolidation measures, the repeal of interest rate caps is likely to give the Central Bank space to pursue an expansionary policy, leading to a gradual recovery in credit growth and boosting the economy over the coming period.</p>
		</div>
	</section>

	<!-- Morocco -->
	<section class="section section-double right">
		<div class="image col-lg-6" style="background-position: right center">
			<div class="bg-image"><img src="assets/img/countries/kuwait.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Kuwait</h2>
			<p>Geopolitical risks and low oil prices are likely to continue weighing on Kuwait’s growth outlook, which we expect to remain moderate in the coming year. Driven by an expansionary fiscal policy, the country’s robust fiscal position will likely continue to provide the government with ample space to provide support to overall GDP growth. We expect non-oil real GDP growth to remain largely unchanged at 2.5%.</p>
		</div>
	</section>

	<!-- Jordan -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/lebanon.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Lebanon</h2>
			<p>Political uncertainty will continue to weigh down on Lebanese economic activity until a new government is formed, making for a challenging year ahead. Capital restrictions and restrictions on cash withdrawal from banks will continue to negatively pressure foreign-denominated bond yields, forcing investors to cautiously await economic reforms. To ensure financial stability, Lebanon’s monetary authorities must find measures to attract investors and maintain deposit inflows.</p>
		</div>
	</section>

	<!-- Lebanon -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/mauritius.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Mauritius</h2>
			<p>Aided by low inflation and enhanced activity in the services and construction segments, Mauritius is expected to maintain a positive growth trajectory in 2020, with real GDP growth forecast at 4%. However, the country’s current account deficit is set to widen due to lackluster merchandise exports and rising imports, a trend driven partially by public infrastructure projects.</p>
		</div>
	</section>

	<!-- Kuwait -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/morocco.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Morocco</h2>
			<p>Growth in Morocco is set to accelerate, with the agricultural sector set to witness a marked recovery in light of an expected improvement in seasonal rains. Non-agricultural growth is also set to accelerate on the back of growth in the utilities, trade and tourism sectors. Monetary and fiscal policies will likely continue to support economic growth growth, leveraging low inflation, accommodative global monetary policies and a narrowing fiscal deficit. </p>
		</div>
	</section>

	<!-- Iraq -->
	<section class="section section-double right">
		<div class="image col-lg-6" style="background-position: center right;">
			<div class="bg-image"><img src="assets/img/countries/nigeria.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Nigeria</h2>
			<p>In absence of the authorities’ willingness to adopt much-needed structural reforms, economic challenges are likely to persist. Growth is forecast to exceed 2% in 2020, although this rate will not be enough to generate the employment needed by the country’s rapidly growing labour force. A planned increase in the VAT rate and minimum wage are likely to increase inflationary pressures in 2020.</p>
		</div>
	</section>

	<!-- Bangladesh -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/oman.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Oman</h2>
			<p>A rebound in oil prices has provided much-needed relief to the Oman’s hydrocarbon sector, which is displaying stronger growth. Meanwhile, efforts to diversify the economy have begun to come to fruition, and non-hydrocarbon growth is likely to increase gradually over the medium term.  Nevertheless, challenges continue to be posed, especially due to delays in the introduction of fiscal reforms, including a value-added tax.</p>
		</div>
	</section>

	<!-- Pakistan -->
	<section class="section section-double right">
		<div class="image col-lg-6" style="background-position: 30% center">
			<div class="bg-image"><img src="assets/img/countries/pakistan.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Pakistan</h2>
			<p>Economic stability is gradually being restored, with the current account deficit narrowing 73% Y-o-Y in first four months of the fiscal year. Fiscal deficit targets agreed with the IMF continue to be met, while the PKR has appreciated slightly in the year to date and the SBP has started to build its reserve position. Although inflation is likely to remain elevated over the coming months, it is expected to ease towards the end of FY20, creating some room for monetary easing as the government seeks to support a recovery in economic activity.</p>
		</div>
	</section>

	<!-- Sri lanka -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/qatar.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Qatar</h2>
			<p>Qatar’s economy will likely stall over the coming year as its growth cycle matures. Sharp weakness in the non-oil sector comes as population growth slows down, while a decrease in project awards indicates that non-oil growth will likely remain subdued. Nevertheless, Qatar will continue to enjoy solid fiscal and external positions on the back of its hydrocarbon revenues, while the fiscal consolidation measures adopted in recent years may provide additional support.</p>
		</div>
	</section>

	<!-- Mauritius -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/rwanda.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Rwanda</h2>
			<p>Rwanda is likely to maintain robust economic growth, helped by the export sector and the government’s drive to increase domestic investment. The country’s business environment has seen major improvement in recent times, benefiting from the implementation of 25 reform measures. These have allowed the country to attain a leading competitiveness ranking among African nations.</p>
		</div>
	</section>

	<!-- Zimbabwe -->
	<section class="section section-double left">
		<div class="image col-lg-6" style="background-position: center center">
			<div class="bg-image"><img src="assets/img/countries/saudi-arabia.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Saudi Arabia</h2>
			<p>Saudi Arabia’s expansionary fiscal policy and the government’s commitment to implementing wide-ranging social reforms is likely to ensure a strong pickup in non-oil economic activity. Growth will be boosted by the government’s investment impetus, with several projects already in the pipeline for next year. Long-term growth will remain dependent on the ability of the government to deliver on its ambitious Vision 2030 reforms.</p>
		</div>
	</section>

	<!-- Botswana -->
	<section class="section section-double right">
		<div class="image col-lg-6" style="background-position: center center">
			<div class="bg-image"><img src="assets/img/countries/sri-lanka.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Sri Lanka</h2>
			<p>Following the shock of the Easter Sunday terrorist attacks, Sri Lanka’s growth rate is set to stage a gradual recovery in 2020, reaching 3.5% against 2.7% in 2019. Growth will be driven by a recovery in the tourism sector. Nevertheless, the country’s outlook remains challenging with a volatile political environment and delays (and in a number of incidents reversals) in efforts to strengthen public revenues. Recent developments illustrate these challenges, with the Central Bank Governor resigning his post and the state reducing VAT rates.</p>
		</div>
	</section>

	<!-- Ghana -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/tanzania.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Tanzania</h2>
			<p>Presidential elections planned for 2020 will see President Magufuli run for a second term, making it likely that the government will push for additional spending during the year, exploiting the recent unfreezing of funds allocated by the World Bank funds. These funds will now be pumped into the economy. However, Tanzania remains in need of economic reforms to boost taxes and improve the business environment.</p>
		</div>
	</section>

	<!-- Kenya -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/turkey.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Turkey</h2>
			<p>Coming on the back of a stimulus package introduced by the government, Turkey’s economy has begun to show signs of recovery following the sharp devaluation of the Lira in 2018. As the currency has stabilized and market sentiment improved, inflation will likely decline steeply, although growth will remain contingent on the sustained implementation of reforms. </p>
		</div>
	</section>

	<!-- Nigeria -->
	<!-- <section class="section section-double left">
		<div class="image col-lg-6"  style="background-position: center center">
			<div class="bg-image"><img src="assets/img/countries/uganda.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Uganda</h2>
			<p>Over 2019. Turkey’s economy is expected to adjust to the sharp devaluation of the Lira, ensued higher inflation
				and tightening of its monetary policy, likely resulting in a contraction in economic activity.</p>
		</div>
	</section> -->

	<!-- Rwanda -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/uganda.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Uganda</h2>
			<p>Uganda will need to follow through on its investments in the oil sector in order to maintain the robust economic growth it has recently enjoyed. Monetary authorities have reduced policy rates in accordance with the low inflationary trajectory. Expansionary monetary policy should continue to boost the financial sector and lead to a stable Shilling. On the other hand, continued delays in the implementation of fiscal measures to boost non-tax revenues are likely to widen the overall deficit.</p>
		</div>
	</section>

	<!-- Tanzania -->
	<section class="section section-double right">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/uae.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>UAE</h2>
			<p>The UAE economy is set to see an uptick in economic activity with the onset of Dubai’s Expo 2020, which is expected to boost the aviation and hospitality sectors significantly. Beyond the Expo, the economy will remain subject to structural and cyclical impediments. Weaker domestic and external demand due to a stronger dollar and lower oil prices will continue to weigh down on growth unless the government delivers on its reforms to diversify the economy’s growth drivers.</p>
		</div>
	</section>

	<!-- Uganda -->
	<section class="section section-double left">
		<div class="image col-lg-6">
			<div class="bg-image"><img src="assets/img/countries/vietnam.jpg" alt=""></div>
		</div>

		<div class="content col-lg-6">
			<h2>Vietnam</h2>
			<p>Despite mounting risks in light of a turbulent external environment, Vietnam’s economy is expected to maintain robust growth going into the year. However, the country’s export-oriented economy is already feeling the brunt of a weakening global macroeconomic backdrop, which we expect will continue to pose risks to the manufacturing and export sectors.</p>
		</div>
	</section>

	<!-- <section class="section image-section" style="height: 300px">
		<div class="bg-image" style="background-attachment: fixed">
			<img src="./assets/img/backgrounds/stocks.jpg" alt="" />
		</div>
	</section> -->

	<!-- <section class="section">
		<div class="container">
			<div class="no-free-will animated" data-animation="fadeInUp">
				<div class="timeline-content-navigation">
					<a href="#" class="prev">
						<span class="icon icon-arrows-03"></span>
					</a>
					<a href="#" class="next">
						<span class="icon icon-arrows-04"></span>
					</a>
				</div>

				<div class="markets slick">
					<div>
						<div class="row">
							<div class="col-md-12">
								<h5>A shifting global dynamic</h5>
								<p>
									• Will the structural growth drivers and
									strong fundamentals of FEMs see them
									withstand current headwinds and continue
									to present compelling investment
									opportunities? Or will EM capital
									outflows see the resurgence of an
									emerging markets' crisis?
								</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-12">
								<h5>Outlook for China and impact of FEM</h5>
								<p>
									• How does a strengthening US dollar
									affect fiscal and FX policy in FEMs with
									rising dollar-denominated debt?
								</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-12">
								<h5>
									Supportive economic policies make for
									promising markets in MENA and FEM
								</h5>
								<p>
									Foreign capital flows are likely to
									continue favoring Egypt as the country
									delivers on its economic reform program,
									with falling interest rates and
									accelerating growth set to drive strong
									stock performance and positioning Egypt
									as a top pick within MENA and FEM.
									Nigeria is also at the forefront of FEM,
									where last year's devaluation, the
									recovery in oil prices and attractive
									valuations together promise good
									returns.
								</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-12">
								<h5>
									Potential FTSE and MSCI market upgrades
									bode well for passive flows
								</h5>
								<p>
									The continued increase of
									passive-managed funds is likely to
									ensure a big bang for the pending FTSE
									and MSCI upgrades in Kuwait and Saudi
									Arabia (passive flows will be well over
									USD10 billion for KSA). Meanwhile,
									Vietnam, a major frontier market, still
									has work to do on FOLs before it can
									join the watch list for an MSCI upgrade.
									It's also likely that new benchmarks for
									investing in smaller emerging and
									frontier markets will emerge over the
									next few years.
								</p>
							</div>
						</div>
					</div>

					<div>
						<div class="row">
							<div class="col-md-12">
								<h5>
									Elections and political impact on MENA
									and FEM
								</h5>
								<p>
									Political overhangs partly explain the
									large valuation discrepancies between
									FEM countries in late 2017. Elections
									will be a key focus in 2018, notably in
									Pakistan with the ruling party having
									faced difficulties in 2017. The
									political timetable could also affect
									reform momentum in Egypt, Nigeria and,
									potentially, Lebanon. Meanwhile,
									investors in Saudi Arabia will be
									looking for clarity on the government's
									plans to revive growth after several
									difficult years. With Qatar being one of
									the worst performing markets of 2017,
									value has clearly opened up, but lasting
									recovery in that market is unlikely
									until the political outlook in the Gulf
									has improved. Overall, tensions within
									MENA are likely to mean that regional
									markets will trade at a discount for EM
									peers.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> -->

	<section class="section gray-clr-bg">
		<div class="container">
			<div class="no-free-will">
				<div class="row">
					<div class="bottom-links">
						<div class="col-md-6">
							<a href="#" class="btn btn-sm btn-secondary btn-block">Participation Guidelines (Presenters)</a>
						</div>
						<div class="col-md-6">
							<a href="#" class="btn btn-sm btn-secondary btn-block">Brochure (Investors)</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    </Layout>
</template>

<script>

import Layout from '@/components/layouts/Layout.vue'

export default {
  name: 'Markets',
  components: {Layout}
};
</script>
